<spark-layout>
  <layout-content>

    <div class="row">
      <div class="col contacts">
        <!-- header -->
        <div class="contacts__header">
          <div class="row">
            <div class="col align-self-center">
              <h2 class="m-none">Contacts</h2>
            </div>

            <!-- btn / reassign -->
            <ng-container *ngIf="contactReassignmentEnabled">
              <div class="col-auto ml-auto align-self-center order-10">
                <lds-button
                  iconBefore="transfer-between"
                  appearance="default"
                  (onClick)="openReassign()">
                  Reassign
                </lds-button>
              </div>
            </ng-container>

            <!-- btns -->
            <div class="col-auto order-11">
              <lds-button
                appearance="secondary"
                (click)="openModal(tplNewContact)">
                New Contact
              </lds-button>
            </div>
          </div>
        </div>

        <!-- Filter outside appLoad to prevent re-creation -->
        <div class="contacts__filters" [formGroup]="form">
          <spark-contact-filters
            identifier="contact-list"
            formControlName="filter"
            (sortOptionChanged)="onSortSelected($event)"
            [defaultFilter]="defaultFilterOptions"
            [users]="(assignableUsers$ | async) || emptyUserList">
          </spark-contact-filters>
        </div>

        <!-- list of contacts -->
        <div class="contacts__list">
          <ng-container *appLoad="let load of contacts$">
            <!-- Loading overlay for searches -->
            <app-loading-overlay *ngIf="isSearching" message="Searching..."></app-loading-overlay>
            
            <ng-container *ngIf="load.length; else tplNoResults">
              <spark-contacts-contact-list-view
                [contacts]="load | sortBy: selectedSortOption"
                [users]="(assignableUsers$ | async) || emptyUserList"
                [isNavigatable]="true">
              </spark-contacts-contact-list-view>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>

  </layout-content>
</spark-layout>

<!-- templates -->

<!-- tpl / new contact -->
<ng-template #tplNewContact>
  <spark-contacts-entity-type-selector
    (closed)="closeModal()"
    (selected)="addContact($event)">
  </spark-contacts-entity-type-selector>
</ng-template>

<!-- tpl / no results -->
<ng-template #tplNoResults>
  <!-- search and/or filters -->
  <ng-container *ngIf="hasFiltersApplied; else tplNoResultsWithoutFilter">
    <lds-empty-state
      heading="No matching results found"
      message="You may want to try refining your search keywords or adjusting your filters.">
    </lds-empty-state>
  </ng-container>

  <!-- no contacts -->
  <ng-template #tplNoResultsWithoutFilter>
    <lds-empty-state
      heading="No contacts found"
      message="Looks like you haven't added any contacts just yet. To get started, click 'New Contact'.">
    </lds-empty-state>
  </ng-template>
</ng-template>
